import { render } from "./HorarioDocumentModal.vue?vue&type=template&id=38abd304"
import script from "./HorarioDocumentModal.vue?vue&type=script&lang=js"
export * from "./HorarioDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__